/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {voidTransaction} from '../api'

export const useMutationVoidTransaction = createReactQueryMutationHook('voidTransaction', voidTransaction)
